export const PRODUCT_UPLOAD_DOCUMENTATION =
  "https://ancient-dosa-ac5.notion.site/Bulk-Product-Update-guidelines-2e3abfbfc0b68024acc4eca910aff757"

export const config = {
  DATA_TRANSFER_TEMPLATE:
    "https://docs.google.com/spreadsheets/d/12ge5ysxM5ZSdiez5QSNjFA5IfOIG17pXJ_4DqN7gCus/export?format=xlsx",
  BUSINESS_PARTNER_IMPORT_TEMPLATE: `${import.meta.env.VITE_BASE_API_URL}/v1/client-settings/business-partner-import-template`,
  ECO_MODULATION_IMPORT_TEMPLATE: `${import.meta.env.VITE_BASE_API_URL}/v1/eco-modulations/import-template`,
  DATA_TRANSFER_DOCS:
    "https://ancient-dosa-ac5.notion.site/Trace-For-Good-Data-onboarding-guide-7a48d956dfcc4402810fc85dfdb28ddc",
  MAX_FILE_SIZE_BYTES: 200 * 1024 ** 2, // 200 MB in bytes
}
